import React from "react";
import { Redirect } from "react-router-dom";
import App from "./app";

// `authResolved` is what stops this bouncing people out of a page they are
// legitimately signed in to. Restoring a Firebase session on reload takes a
// network round trip, and for that whole window `isAuthenticated` is false
// simply because the answer has not arrived yet — not because the admin is
// signed out. Redirecting on that produced a visible flash of the login form
// on every reload, and the app then landed on the dashboard instead of the
// page that was open, because by the time auth resolved the URL really was
// the login route.
//
// So: redirect only once auth has actually been decided. Until then App still
// renders, showing the shell with a loader in the body (see allRoutes).
//
// This applies in development too. It used to be production-only, which let a
// signed-out browser on the dev server keep showing the protected pages.
const PrivateLayout = ({ isAuthenticated, authResolved = true, children }) => {
  if (authResolved && !isAuthenticated) {
    return <Redirect to="/" />;
  }

  return <App>{children}</App>;
};

export default PrivateLayout;
